module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropdown-confirmation', {
    attrs: {
      "name": "saveChart",
      "size": "lg",
      "direction": "right",
      "triggerBtnClass": "btn-light",
      "triggerBtnHtml": "<i class=\"fa fa-pie-chart\"></i>&nbsp;&nbsp;Save Chart",
      "confirmBtnClass": "btn-success",
      "confirmBtnHtml": "<i class=\"fa fa-check\"></i>&nbsp;&nbsp;Save"
    },
    on: {
      "confirm": _vm.saveChart
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', [_c('strong', [_vm._v("SAVE CHART")]), _c('br'), _c('br'), _vm._v("\n                    Give this report a name in order to re-run or reference it later. Saved reports are visible on the dashboard.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Chart Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('dropdown', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart_type),
      expression: "chart_type"
    }],
    attrs: {
      "list": _vm.types
    },
    domProps: {
      "value": (_vm.chart_type)
    },
    on: {
      "input": function($event) {
        _vm.chart_type = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chart_type != 'Value'),
      expression: "chart_type != 'Value'"
    }],
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("X Axis")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('dropdown', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.xaxis),
      expression: "xaxis"
    }],
    attrs: {
      "list": _vm._f("colnames")(_vm.xOpts)
    },
    domProps: {
      "value": (_vm.xaxis)
    },
    on: {
      "input": function($event) {
        _vm.xaxis = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Y Axis")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('dropdown', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yaxis),
      expression: "yaxis"
    }],
    attrs: {
      "list": _vm._f("colnames")(_vm.yOpts)
    },
    domProps: {
      "value": (_vm.yaxis)
    },
    on: {
      "input": function($event) {
        _vm.yaxis = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chart_type != 'Value'),
      expression: "chart_type != 'Value'"
    }],
    staticClass: "row lined"
  }, [_c('div', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Data Points")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('dropdown', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.num_results),
      expression: "num_results"
    }],
    attrs: {
      "list": _vm.points
    },
    domProps: {
      "value": (_vm.num_results)
    },
    on: {
      "input": function($event) {
        _vm.num_results = $event
      }
    }
  })], 1)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6429645e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/SaveChart.vue
// module id = 398
// module chunks = 0